//this is being used by tickets page and confirmation page only.. dont use this in details or preview page again
import React, { Component } from 'react';
//import ReactDOM from 'react-dom';

class LoadingDiv extends Component {
  
  render() {

      return (<div id="loader-wrapper">
                  <div id="fountainG">
                    <div id="fountainG_1" className="fountainG"></div>
                    <div id="fountainG_2" className="fountainG"></div>
                    <div id="fountainG_3" className="fountainG"></div>
                    <div id="fountainG_4" className="fountainG"></div>
                    <div id="fountainG_5" className="fountainG"></div>
                    <div id="fountainG_6" className="fountainG"></div>
                    <div id="fountainG_7" className="fountainG"></div>
                    <div id="fountainG_8" className="fountainG"></div>
                  </div>
              </div>
             );
  }
}

export default LoadingDiv;


// WEBPACK FOOTER //
// ./src/mobile/mobLoadingDiv.js